import { CUSTOMER_APIS } from "@/api_framework/api_config";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setLoading } from "@/app_redux/reducers/loading_reducer";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "../../useAPIUtils";
import { IVaccinationInputResponse } from "@/api_framework/api_modals/Vaccination";
import { setVaccinationInputData } from "@/app_redux/reducers/slices/auth/customer_profile_slice";

AxiosCurlirize(axios, () => {});

export const useVaccinationInputListAPI = () => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();

  const execute = useCallback(
    async (petId: string, userId: string) => {
      try {
        dispatch(
          setLoading({
            key: "isvaccinationTableLoading",
            status: true,
          }),
        );
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response = await axios
          .get(`${CUSTOMER_APIS?.VACCINATION_INPUT_LIST?.baseURL}${petId}/${userId}/`, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IVaccinationInputResponse>) => {
            if (res.data.status === true) {
              dispatch(setVaccinationInputData(res.data.data));
              dispatch(
                setLoading({
                  key: "isvaccinationTableLoading",
                  status: false,
                }),
              );
              return { status: true, message: res.data.message };
            } else {
              dispatch(setVaccinationInputData(null));
              dispatch(
                setLoading({
                  key: "isvaccinationTableLoading",
                  status: false,
                }),
              );
              return { status: false, message: null };
            }
          })
          .catch((e: AxiosError) => {
            dispatch(setVaccinationInputData(null));
            sendCurl(e.config["curlCommand"]);
            captureError(e);
            dispatch(
              setLoading({
                key: "isvaccinationTableLoading",
                status: false,
              }),
            );
            const message = e.response.data as any;
            return { status: false, message: message.message };
          });
        return response;
      } catch (e: any) {
        dispatch(
          setLoading({
            key: "isvaccinationTableLoading",
            status: false,
          }),
        );
        dispatch(setVaccinationInputData(null));
        captureError(e);
      }
    },
    [dispatch],
  );
  return { execute };
};
